'use strict';

const facebookShareLinks = document.getElementsByClassName('js-some-share__link-button--facebook');

for (let i = 0 ; i < facebookShareLinks.length ; i++) {
    const facebookShareLink = facebookShareLinks[i];
    new Vue({
        el: facebookShareLink,
        name: 'Facebook Share Link',
        methods: {
            shareOnFacebook() {
                const u=location.href;
                const t=document.title;
                window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),'sharer','toolbar=0,status=0,width=626,height=436');
                return false;
            }
        }
    });
}

